import { Order } from "@amzn/ito-client";
import { OrderStatus } from "common/types/orders-types";
import { OrdersServiceFactory } from "lib/services";
import { IItemVersion } from "lib/types/items";
import { useEffect, useState } from "react";

export interface useOrdersTableResult {
  order: Order | undefined;
  activeOrder: Order | undefined;
  loadingOrders: boolean;
}

const nonFinalOrderStatuses: string[] = [
  OrderStatus.APPROVED,
  OrderStatus.NEW,
  OrderStatus.PENDING_APPROVAL,
  OrderStatus.PROCESSING,
];

export function useProductDetailsPage(
  taxonomyId: string,
  selectedVersion: IItemVersion | undefined
): useOrdersTableResult {
  const [order, setOrder] = useState<Order>();
  const [activeOrder, setActiveOrder] = useState<Order>();
  const [loadingOrders, setLoadingOrders] = useState(true);

  useEffect(() => {
    const fetchOrder = async (ItemTaxonomyId: string) => {
      setLoadingOrders(true);
      try {
        const result = await OrdersServiceFactory.getInstance(ItemTaxonomyId).GetOrders_My("", 1, "", {
          itemId: [taxonomyId],
        });
        setOrder(result.orders?.[0]);
        setActiveOrder(result.orders?.find((order) => order.status && nonFinalOrderStatuses.includes(order.status)));
      } catch (error) {
        console.error("Error fetching order:", error);
      } finally {
        setLoadingOrders(false);
      }
    };

    if (selectedVersion) {
      fetchOrder(selectedVersion.taxonomyId);
    } else {
      fetchOrder(taxonomyId);
    }
  }, [taxonomyId, selectedVersion]);

  return {
    order,
    activeOrder,
    loadingOrders,
  };
}
